// The InSight Journal — essay registry.
// To publish a new essay: copy an entry, set published: true, and fill in
// excerpt + content. Content blocks support: { heading, paragraphs[] }.
// The essay appears on the homepage Journal grid and at /journal/<slug>.

export const JOURNAL_ARTICLES = [
  {
    slug: "hba1c-high-despite-eating-healthy",
    title: "Why does my HbA1c remain high despite eating 'healthy'?",
    category: "Understanding Your Reports",
    published: true,
    excerpt:
      "Eating “healthy” does not automatically mean healthy blood glucose. Why HbA1c can stay high even on home-cooked food — and the question worth asking instead.",
    content: [
      {
        heading: null,
        paragraphs: [
          "“Doctor, I eat healthy. I've stopped sugar. I hardly eat junk. So why is my HbA1c still high?”",
          "A surprisingly common question.",
          "The uncomfortable truth is:",
          "**Eating “healthy” does not automatically mean having healthy blood glucose.**",
          "You can eat homemade food, avoid sweets and still have a high HbA1c.",
          "Why?",
          "Because **HbA1c reflects your average glucose exposure over months — not whether your food looks healthy on a plate.**",
          "A few things often get missed:",
        ],
      },
      {
        heading: "1. Healthy carbs are still carbs.",
        paragraphs: [
          "Oats, poha, idli, dalia, brown rice, roti, fruit and dates can all be nutritious. But quantity and your individual glucose response matter.",
        ],
      },
      {
        heading: "2. Your liver makes glucose too.",
        paragraphs: [
          "With insulin resistance, the liver may release more glucose than it should — so fasting sugar can remain high even when you haven't eaten.",
        ],
      },
      {
        heading: "3. Muscle matters.",
        paragraphs: [
          "Muscle is a major site for glucose disposal. Less muscle and less physical activity can mean poorer glucose control. This is why resistance training can be metabolically powerful.",
        ],
      },
      {
        heading: "4. Timing matters.",
        paragraphs: [
          "Large meals, frequent snacking, late-night eating and prolonged inactivity can affect glucose even when the individual foods appear “healthy.”",
        ],
      },
      {
        heading: "5. Sleep and stress matter.",
        paragraphs: [
          "Poor sleep, chronic stress and conditions such as sleep apnea can worsen insulin sensitivity.",
        ],
      },
      {
        heading: "And here's the bigger point:",
        paragraphs: [
          "**Stop judging metabolic health one food at a time.**",
          "Instead of asking:",
        ],
        items: ["Is rice bad?", "Is fruit okay?", "Should I switch to millet?"],
      },
      {
        heading: null,
        paragraphs: [
          "Ask: **What happens to MY glucose after I eat?**",
          "Look at the bigger picture — fasting glucose, post-meal glucose, waist and visceral fat, muscle mass, physical activity, sleep, medications and overall diet.",
          "Because sometimes the problem isn't that you're eating *unhealthy* food.",
          "**It's that your metabolism isn't handling even “healthy” food efficiently.**",
        ],
      },
      {
        heading: "So don't just ask: “Am I eating healthy?”",
        paragraphs: ["**Ask: “Is my metabolism healthy?”**"],
      },
    ],
  },
  {
    slug: "triglycerides-what-your-report-may-be-telling-you",
    title: "Triglycerides: what your report may be telling you",
    category: "Metabolism",
    published: false,
    excerpt: "",
    content: [],
  },
  {
    slug: "fatty-liver-isnt-just-a-liver-problem",
    title: "Fatty liver isn't just a liver problem",
    category: "Metabolism",
    published: false,
    excerpt: "",
    content: [],
  },
  {
    slug: "why-weight-loss-becomes-harder-after-40",
    title: "Why weight loss can become harder after 40",
    category: "Weight & Insulin Resistance",
    published: false,
    excerpt: "",
    content: [],
  },
  {
    slug: "what-actually-matters-when-choosing-a-supplement",
    title: "What actually matters when choosing a supplement?",
    category: "Lifestyle",
    published: false,
    excerpt: "",
    content: [],
  },
  {
    slug: "insulin-resistance-at-a-normal-weight",
    title: "Can you have insulin resistance at a normal weight?",
    category: "Weight & Insulin Resistance",
    published: false,
    excerpt: "",
    content: [],
  },
];
